import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../../api/apiService";
import { Spinner } from "react-bootstrap";
import { getBadgeClass } from "../../config/utils";

function PrintEmployeeMonthlyAttend() {
  const [searchParams] = useSearchParams();
  const date = searchParams.get("date");
  const shift = searchParams.get("shift");
  const company = localStorage.getItem("company");

  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAttendanceReport = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(
          `daily-report?date=${date}&shift=${shift}`
        );
        setData(response.data);
      } catch (err) {
        console.error("Error fetching attendance report:", err);
        toast.error("Failed to fetch data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAttendanceReport();
  }, [date, shift]);

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        window.print();
        window.addEventListener("afterprint", handleAfterPrint);
      }, 1000);
    }
    return () => {
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [isLoading]);

  const handleAfterPrint = () => {
    window.close();
  };

  const { employee, summary, employees_attendance } = data || {};

  return (
    <div className="text-dark" style={{ padding: "20px" }}>
      <h2 style={{ textAlign: "center" }}>Daily Report</h2>
      {employee?.name && (
        <h3 style={{ textAlign: "center" }}>{employee.name}</h3>
      )}

      <p>
        <strong>Date:</strong> {date} | <strong>Shift:</strong>{" "}
        {summary?.shift_name}
      </p>

      {summary && (
        <p>
          <strong>Present:</strong> {summary?.present_employees} |{" "}
          <strong>Absent:</strong> {summary?.absent_employees}
        </p>
      )}
      {summary && (
        <p>
          <strong>Employees:</strong> {summary?.total_employees} |{" "}
          <strong>Total Hours:</strong> {summary?.total_hours} |{" "}
          <strong>Total Overtime:</strong> {summary?.total_overtime}
        </p>
      )}

      {isLoading ? (
        <div className="text-center mt-3">
          <Spinner animation="border" variant="primary" />
          <span className="ms-2">Loading...</span>
        </div>
      ) : employees_attendance?.length > 0 ? (
        <div className="table-responsive mb-3">
          <table className="table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Check In</th>
                <th>Check Out</th>
                <th>Status</th>
                <th>Total Hours</th>
                <th>Overtime</th>
              </tr>
            </thead>
            <tbody>
              {employees_attendance.map((record, index) => (
                <tr key={index}>
                  <td>{record.employee_name}</td>
                  <td>{record.check_in || "--"}</td>
                  <td>{record.check_out || "--"}</td>
                  <td>
                    <span className={`text-${getBadgeClass(record.status)}`}>
                      {record.status}
                    </span>
                  </td>
                  <td>{record.total_hours} hours</td>
                  <td>{record.overtime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <tbody>
          <tr>
            <td colSpan="9" className="text-center">
              No attendance records found.
            </td>
          </tr>
        </tbody>
      )}

      {!isLoading && <h5>{company}</h5>}
    </div>
  );
}

export default PrintEmployeeMonthlyAttend;
